import {Injectable, signal} from '@angular/core';
import {TelegramNotifications} from "../types/telegram-notifications.types";

@Injectable({
  providedIn: 'root'
})
export class TelegramNotificationsStateService {
  private _telegramNotificationsState = signal<Array<TelegramNotifications>>([]);
  public telegramNotificationsState = this._telegramNotificationsState.asReadonly();

  public setTelegramNotificationsState(telegramNotifications: Array<TelegramNotifications>): void {
    this._telegramNotificationsState.set(telegramNotifications);
  }

  public getTelegramNotificationsById(id: number): number {
    return this.telegramNotificationsState().find(i => i.recordCalendarId === id)?.notificationCount || 0;
  }

  public resetTelegramNotificationsState(): void {
    this._telegramNotificationsState.set([]);
  }
}
